/*
 * @Author: yuanhao
 * @Date: 2019-03-05 09:06:36
 * @Last Modified by: yh
 * @Last Modified time: 2019-07-17 14:53:27
 * @description:  filter 的引用目录
                  添加说明 这里的refs 不是响应式的 也不是官方所推荐的
*/
<template>
  <div class="side-wrapper">
    <div class="top flexbt">
      <div class="top-item">
        <span class="iconfont icon-top icon-shaixuan1"></span>
        <span>筛选</span>
      </div>
      <div class="top-item reset" @click="reset">
        <span class="iconfont icon-top icon-zhongzhi"></span>
        <span>重置</span>
      </div>
    </div>

    <div class="filter-list" v-if="filterList.length">
      <!-- 显示文本 -->
      <component
        v-for="(item,index) in labelList"
        :key="index+item.name"
        :is="item.name"
        :initdata="item.data"
      ></component>
      <!-- 筛选器 -->
      <component
        v-for="(item,index) in filterList"
        @event="item.event"
        :initdata="item.data"
        :filterListIndex="index"
        :is="item.name"
        :ref="item.name"
        :key="index"
        :debounceTime="debounceTime"
      ></component>
      <!-- <hello
        v-for="(item,index) in filterList"
        @event="item.event"
        :initdata="item.data"
        :filterListIndex="index"
        :key="item.name"
      ></hello>-->
    </div>
  </div>
</template>

<script>
import Vue from "vue";
/* 加载模块 */
var load = function(lists) {
  let obj = {};
  lists.forEach(item => {
    obj[item] = Vue.component(item, () => import(`./${item}`));
  });
  return obj;
};
export default {
  name: "rightSide",
  components: {
    ...load([
      "hello",
      "search",
      "authstate",
      "sort",
      "microorg",
      "community",
      "origin",
      "addOrigin",
      "division",
      "singleDivision",
      "filter_label",
      "selecter",
      "filterType"
    ])
  }, // 所有filter的组件需手动在此注入
  created() {},
  mounted() {},
  data() {
    return {
      debounceTime: 800 // 控制复选框触发时间间隔
    };
  },
  computed: {
    filterList: function() {
      return this.$store.state.filterList;
      console.log(this.$store.state.filterList)
    },
    labelList() {
      return this.$store.state.labelList;
    }
  },
  methods: {
    // 由于refs 不是响应式的 会出现refs为空的情况 加上筛选以过滤
    reset() {
      try {
        for (let item in this.$refs) {
          this.$refs[item].length && this.$refs[item][0].reset();
        }
      } catch (error) {
        console.log(`[sys] filter index` + error);
      }
    }
  }
};
</script>

<style scoped>
.side-wrapper
  >>> .ivu-collapse
  > .ivu-collapse-item.ivu-collapse-item-active
  > .ivu-collapse-header
  > i {
  font-size: 20px;
  color: #999;
}
.side-wrapper
  >>> .ivu-collapse
  > .ivu-collapse-item
  > .ivu-collapse-header
  > i {
  margin-right: 0;
  font-size: 20px;
  color: #999;
}
.flexbt {
  display: flex;
  justify-content: space-between;
}
/* 溢出显示滚动条 */
.side-wrapper {
  width: 260px;
  min-height: 100%;
  height: 100%;
  overflow: auto;
  border-left: 1px solid #ddd;
  background: #fff;
  position: fixed;
  right: 0px;
  padding-bottom: 100px;
}
/* 重置滚动条样式 */
.side-wrapper::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  /* height: 4px; */
}
.side-wrapper::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}
.side-wrapper::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
.top {
  color: #677b9e;
  padding: 18px 20px;
  border-bottom: 1px solid #dedede;
  line-height: 1;
}
.top-item {
  display: flex;
  align-items: center;
  cursor: default;
}
.reset {
  cursor: pointer;
}
.icon-top {
  margin-right: 6px;
}
</style>
